import { Box, Button, Stack, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import styles from "../../styles/pages/mymessagePurchasedRequest.module.scss";
import PerfectScrollbar from "react-perfect-scrollbar";
import "react-perfect-scrollbar/dist/css/styles.css";
import MessageBoxEven, { IFile } from "../MessageBoxEven/MessageBoxEven";
import assest from "../../json/assest";
import useFetch from "../../hooks/api/useFetch";
import {
  concatHostAndImagePath,
  getStyledDateTime,
  styledDateTime,
} from "../../lib/functions/utils.lib";
import PurchaseMessageTypeBox from "./PurchaseMessageTypeBox";
import { useParams } from "react-router";
import axiosInstance from "../../api/axiosInstance";
import useNotiStack from "../../hooks/useNotistack";
import ApiLoader from "../Loaders/ApiLoader";

const PurchaserequestDetailsRightPanel = (props) => {
  const { id } = useParams();

  const {
    data: messages,
    isError,
    isLoading,
    isSuccess,
    refetch,
    isRefetching,
  } = useFetch(
    ["purchase_request-meassages", id],
    `purchase_request/${id}/messages
        `
  );
  const { toastSuccess } = useNotiStack();

  const [archiveClicked, setArchiveClicked] = useState(
    props?.inquiry?.archive === 1 ? true : false
  );
  useEffect(() => {
    setArchiveClicked(props?.inquiry?.archive);
  }, [props?.inquiry?.archive]);

  const updateArchive = async () => {
    try {
      const formData = new FormData();
      const newArchiveValue = props.inquiry?.archive === 0 ? 1 : 0;
      formData.append("archive", newArchiveValue);

      const data = await axiosInstance.post(
        `admin/update-purchase-request/${props?.inquiry?.id}`,
        formData
      );
      toastSuccess(data?.data?.message);
      props?.refetchPurchaseRequestData();
    } catch (error) {
      console.error(error);
    }
  };

  const getStatus = (inquiry) => {
    if (!inquiry?.status) {
      if (inquiry?.initiated?.name === inquiry?.last_message?.sender?.name)
        return "Need your reply";
      return "Pending";
    }
    return "Resolved";
  };

  return (
    <PerfectScrollbar className={styles.detailsColRight}>
      <Box className={styles.innerColRight}>
        <ApiLoader loading={isLoading || isRefetching} />
        <Box className={styles.messageBoxWrapper}>
          {!props?.respondToInquiry && (
            <Stack
              direction="row"
              flexWrap="wrap"
              alignItems="center"
              className={styles.respond}
            >
              <Button
                onClick={props?.toggleRepondToInquiry}
                disabled={archiveClicked}
              >
                Respond
              </Button>
              <Typography
                className={`${styles.btnResolve} ${styles.btnResolveLrg}`}
                variant="caption"
                onClick={updateArchive}
                style={{ cursor: "pointer" }}
              >
                <strong>Archive</strong>
              </Typography>
            </Stack>
          )}

          {props?.respondToInquiry ? (
            <PurchaseMessageTypeBox
              inquiry={props.inquiry}
              refreshMessages={refetch}
              toggleRepondToInquiry={props?.toggleRepondToInquiry}
            />
          ) : (
            ""
          )}
          <Box className={styles.evenMsgList}>
            {messages?.data?.data?.map((item, index) => {
              return (
                <MessageBoxEven
                  key={index}
                  pfAvatar={item?.sender.image}
                  pfName={item?.sender.name}
                  designation={"N/A"}
                  postedDate={styledDateTime(item?.created)}
                  msgContent={item?.message}
                  type={item?.type}
                  attachFile={item?.attachments}
                />
              );
            })}
          </Box>
        </Box>
      </Box>
    </PerfectScrollbar>
  );
};

export default PurchaserequestDetailsRightPanel;
